<template>
  <div class="address">
    <el-select
      v-model="province"
      class="inline-input"
      style="width: 150px"
      @change="areaChange"
      :disabled="disableAddress"
      placeholder="请选择省份">
      <el-option
        v-for="(key, value) in provinces"
        :key="key"
        :label="key"
        :value="value">
      </el-option>
    </el-select>
    <el-select
    v-model="city"
    class="inline-input"
    style="width: 150px"
    @change="areaChange"
    :disabled="disableAddress"
    placeholder="请选择城市">
      <el-option
        v-for="(key, value) in cities"
        :key="key"
        :label="key"
        :value="value">
      </el-option>
    </el-select>
    <el-select
    v-model="district"
    class="inline-input"
    style="width: 150px"
    @change="areaChange"
    :disabled="disableAddress"
    placeholder="请选择区县">
      <el-option
        v-for="(key, value) in districts"
        :key="key"
        :label="key"
        :value="value">
      </el-option>
    </el-select>
    <el-input
      @blur="areaChange"
      class="inline-input"
      placeholder="所在的街道/村镇及门牌号"
      style="width: 400px"
      :disabled="disableAddress"
      v-model="address">
    </el-input>
    <el-tooltip content="定位" placement="top" effect="light" v-if="module !== 'invoice'">
      <el-button @click="clickAddress"><i class="el-icon-location-outline" style="font-size: 16px;"></i></el-button>
    </el-tooltip>
    <div class="location-wrapper" :class="{'location-addressTop': isAddress}" v-if="mapLocationShow">
      <map-location
        :address="attrValue"
        @closeModal="mapLocationShow = false"
        @update="getMapData">
      </map-location>
    </div>
  </div>
</template>

<script>
let lazy

export default {
  props: {
    attrValue: [String, Object],
    module: {
      type: String
    }
  },
  created () {
    const s = document.createElement('script')
    s.type = 'application/x-javascript'
    s.src = 'https://cdnsaas.xbongbong.com/share/js/china-area.js'
    document.body.appendChild(s)
    s.onload = () => {
      this.area = window.area
    }

    // 初始化地址信息
    if (this.attrValue) {
      this.initAddress(this.attrValue)
    }

    // 如果是工单的服务人员，则禁用地址选择
    if (this.module === 'WOServiceStaff') {
      this.disableAddress = true
    }
  },
  data () {
    return {
      area: {},
      province: '',
      city: '',
      district: '',
      address: '',
      mapLocationShow: false,
      location: [],
      isAddress: false,
      disableAddress: false // 是否禁用地址选择
    }
  },
  computed: {
    provinces () {
      return this.area[86]
    },
    cities () {
      return this.area[this.province]
    },
    districts () {
      // 部分城市没有辖区或辖县，统一以市辖区替代
      if (!this.area[this.city] && this.province) {
        this.area[this.city] = {900001: '市辖区'}
      }
      return this.area[this.city]
    }
  },
  components: {
    MapLocation: (resolve) => {
      require.ensure(['components/fieldtype/address/map-location'], () => resolve(require('components/fieldtype/address/map-location')), 'MapLocation')
    }
  },
  watch: {
    province () {
      this.city = Object.keys(this.cities)[0]
      this.areaChange()
    },
    city () {
      this.district = Object.keys(this.districts)[0]
      this.areaChange()
    }
  },
  methods: {

    // 初始化地址信息
    initAddress (data) {
      if (this.provinces) {
        const province = data.province
        const city = data.city
        const district = data.district
        for (let item in this.provinces) {
          if (this.provinces[item] === province || (this.provinces[item].length === 4 && this.provinces[item].substr(1, 3) === province)) {
            this.province = item
          }
        }
        this.$nextTick(() => {
          for (let item in this.cities) {
            if (this.cities[item] === city) {
              this.city = item
            }
          }
          this.$nextTick(() => {
            for (let item in this.districts) {
              if (this.districts[item] === district) {
                this.district = item
              }
            }
          })
        })
        this.address = data.address
      } else {
        setTimeout(() => {
          this.initAddress(data)
        }, 50)
      }
    },

    areaChange () {
      // 防止被多次触发
      clearTimeout(lazy)
      lazy = setTimeout(() => {
        let obj = {
          province: '',
          city: '',
          district: '',
          address: this.address
        }
        if (this.province) obj.province = this.area[86][this.province].length === 4 && this.area[86][this.province].substr(1, 3) === '北京市' ? '北京市' : this.area[86][this.province]
        if (this.city) obj.city = this.area[this.province][this.city]
        if (this.district) obj.district = this.area[this.city][this.district]
        if (this.location.length) {
          obj.location = this.location
        } else if (this.attrValue.location) {
          obj.location = this.attrValue.location
        } else {
          obj.location = []
        }
        this.$emit('change', obj)
      }, 50)
    },

    // 获取地图数据
    getMapData (data) {
      // 写入已选地址信息
      this.initAddress(data)
      this.location = data.location
      this.areaChange() // 解决第一次验证地址为空的情况new
      setTimeout(() => {
        this.areaChange() // 这里好像是处理地图选取异步存值的问题old
      }, 100)
      // 关闭地图弹窗
      this.mapLocationShow = false
    },

    clickAddress (e) {
      if (document.body.clientHeight - e.clientY < 380) {
        this.isAddress = true
      } else {
        this.isAddress = false
      }
      this.mapLocationShow = true
    }
  }
}
</script>

<style lang="less" scoped>
  .address {
    .inline-input {
      display: inline-block;
      margin: 0 15px 15px 0;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .location-wrapper {
      position: absolute;
      right: 0;
      top: 94px;
      width: 100%;
      height: 400px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      border-radius: 2px;
      background-color: #fff;
      z-index: 100;
      box-sizing: border-box;
      padding: 10px;
    }
    .location-addressTop {
      top: -390px;
    }
  }
</style>


// WEBPACK FOOTER //
// index.vue?640c77ec